import { Envelope } from "../models/envelope.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getUserEnvelopes = (user_id: number): Promise<Envelope[]> => {
    return new Promise<Envelope[]>((resolve, reject) => {
        if(!user_id) return;

        responseHero.get(`${process.env.REACT_APP_API_URL}/userenvelopes/${user_id}`).then((response) => {
            resolve(response.data as Envelope[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};